export function createValidationDataObject(valid = true, message = undefined) { // eslint-disable-line require-jsdoc
    return {
        valid,
        message
    };
}
